/* @twid_ai_start */
/**
 * Load all influencer JSON files
 * @returns {Promise<Array>} Array of influencer data objects
 */
export const loadInfluencerData = async () => {
  try {
    // Get list of all influencer files
    const response = await fetch('/api/files');
    const { files } = await response.json();

    // Load data for each file
    const data = await Promise.all(
      files.map(async (filename) => {
        const response = await fetch(`/${filename}`);
        const jsonData = await response.json();
        return {
          filename,
          data: jsonData
        };
      })
    );

    return data;
  } catch (error) {
    console.error('Error loading influencer data:', error);
    throw error;
  }
};

/**
 * Group the data by a specific property
 * @param {Array} data Array of data objects
 * @param {string} property Property to group by
 * @returns {Object} Grouped data
 */
export const groupDataBy = (data, property) => {
  return data.reduce((acc, item) => {
    const key = item.data[property] || 'undefined';
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});
};
/* @twid_ai_end */ 